import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';

function About() {

   
    return (
        <>
            <Header/>

            <section className="hero-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-5">
                            <h2 className="text-white fw-normal mb-4 mt-3 lh-base">
                                About
                            </h2>
                        </div>
                    </div>
                    {/* <div className="col-md-5 offset-md-2">
                            <div className="text-md-end mt-3 mt-md-0">
                                <img src="assets/images/svg/startup.svg" alt className="img-fluid" />
                            </div>
                        </div> */}
                </div>
            </section>
            <section id="about" className="about section">
                <div className="container p-2 section-title" data-aos="fade-up">
                    <div className="d-flex justify-content-center">
                        <button
                            type="button"
                            className="btn btn-light rounded-pill"
                        >
                            SERVICES
                        </button>
                    </div>
                    <h1 style={{ textAlign: 'center' }}>
                        <span>Credit Card</span> <span className="link-primary">Service</span>
                    </h1>
                </div>
                {/* Section Title */}
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up">
                            <div className="about-content ps-0 ps-lg-2">
                                <h3>"Innovation is not just our Strength; it is our Foundation."</h3>
                                <p>
                                    For the past 9 years, Sai Financial Service has been at the forefront of the financial services industry, mastering credit card services, loan management, and insurance solutions. Our core strength lies in simplifying complex financial products and delivering value-driven solutions to our clients.
                                </p><p>From providing tailored loan disbursement solutions to offering personalized credit card consultancy, Sai Financial Service has continually innovated, always staying ahead of market trends. Before any large-scale rollout, we thoroughly analyze market needs, ensuring every solution we provide is meticulously tailored for maximum impact.</p>
                                <p>Although Sai Financial Service has years of experience, we remain agile, quickly adapting to the evolving financial landscape. We are more than just a financial service provider; we are problem solvers, solution creators, and innovators. Known for delivering customer-centric services, our USP is tackling challenging financial needs with precision and expertise.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
                            <img src="assets/img/about1.webp" alt className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>{/* /About Section */}
            <br />
            <br />
            <section id="about" className="h-30 p-3 text-bg-light">
                <div className="container section-title" data-aos="fade-up">

                    <div className="d-flex justify-content-center">
                        <button
                            type="button"
                            className="btn btn-light rounded-pill"
                        >
                            About
                        </button>
                    </div>
                    <h1 className="text-center fs-1">
                        <span>Our</span> <span className="link-primary">Journey</span>
                    </h1>
                </div>

                {/* Section Title */}
                <div className="container">
                    <div className="row p-3">
                        <div className="col-lg-12 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay={200}>
                            <div className="about-content ps-0 ps-lg-3">
                                <p className="fs-4">
                                    Founded 9 years ago, Sai Financial Service was established to address the growing demand for transparent,
                                    efficient financial solutions in India. Recognizing our ability to deliver honest and reliable services,
                                    we expanded into credit cards, loans, and insurance. By focusing on client challenges and finding sustainable solutions,
                                    we have earned the loyalty of our clients and built lasting relationships.
                                </p>
                                <p className="fs-4">
                                    Our state-of-the-art infrastructure and strong associations with leading banks, financial institutions,
                                    and insurance companies ensure that we are always at the cutting edge of service delivery.
                                </p>
                                <p className="fs-4">
                                    In 2024, Sai Financial Service was recognized for its innovative approach to financial services, receiving
                                    accolades in various industry platforms. Our commitment to transparency, ethical business practices, and
                                    technological innovation continues to drive our growth.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <br />
            <section id="about" className="about section">
                <div className="container section-title" data-aos="fade-up">
                    <div className="d-flex justify-content-center">
                        <button
                            type="button"
                            className="btn btn-light rounded-pill"
                        >
                            About
                        </button>
                    </div>
                    <h1 className="text-center fs-1">
                        <span>What We</span> <span className="link-primary">offer</span>
                    </h1>
                </div>
                {/* Section Title */}
                <div className="container">
                    <div className="row gy-3">
                        <div className="col-lg-12 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay={200}>
                            <div className="about-content ps-0 ps-lg-3">
                                <p className="fs-4">
                                    Our expertise extends across a wide range of financial products, including:
                                </p>
                                <p>
                                </p ><ol className="list-unstyled fs-4">
                                    <li className="fs-4"><b> Credit Cards:</b> Tailored solutions from multiple banks to suit varying needs.</li>
                                    <li className="fs-4"><b>Loans:</b> Personal, business, and home loans with flexible terms.</li>
                                    <li className="fs-4"><b>Insurance:</b> Comprehensive insurance packages, ensuring maximum coverage for our clients.</li>
                                    <li className="fs-4"><b>Credit Card Swipe Up:</b> </li>
                                    <li className="fs-4"><b>Udhyam :</b> </li>
                                    <li className="fs-4"><b>PanCard :</b> </li>
                                    <li className="fs-4"><b>Incometax Services :</b> </li>
                                    <Link to="/service" className="raise">More Services...</Link></ol>
                                <p />
                                <p className="fs-4">
                                    We work closely with our clients, ensuring absolute transparency, mutual trust, and delivering
                                    measurable results. Sai Financial Service stands out by offering cost-effective solutions without compromising on quality.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />

        </>
    )
}

export default About
